import { useEffect } from "react"
import { Grid, AboutUs, ManagementTeam, AboutUsMission } from "../components"
import { Navbar, Footer } from "../layouts"




const HomePage = () => {

    useEffect(() => {
        window.scrollTo({
            top: 0, 
            behavior: 'smooth'
          });
    }, [])
    return (
        <>
        <Navbar/>
        <Grid/> 
        {/* <AboutUsHeader/> */}
        <AboutUs/>
        <AboutUsMission/>
        <ManagementTeam/>
        <Footer/>
        </>

    )
}

export default HomePage